import { create } from "zustand";

type WorkspaceBootstrapState = {
  isWorkspaceInitializing: boolean;
  setWorkspaceInitializing: (isWorkspaceInitializing: boolean) => void;
};

export const useWorkspaceBootstrapStore = create<WorkspaceBootstrapState>(
  (set) => ({
    isWorkspaceInitializing: true,
    setWorkspaceInitializing: (isWorkspaceInitializing) =>
      set({ isWorkspaceInitializing }),
  }),
);
